import { httpClient } from '../http/httpClient'

export interface RegisterParams {
  name: string
  birthDate: string
  email: string
  phone: string
  instagram?: string
  cpf: string
  rg?: {
    number?: string
    uf?: string
    org?: string
    date?: string
  }
  address: {
    zipCode: string
    street: string
    number?: string
    complement?: string
    neighborhood: string
    city: string
    state: string
  }
  password: string
  bankAccount: {
    bank: string
    agency: string
    account: string
  }
  emailMarketing?: boolean
}

interface RegisterResponse {
  _id: string
  name: string
  email: string
  phone: string
  birthDate: string
  address: {
    zipCode: string
    state: string
    city: string
    neighborhood: string
    street: string
    number: string
    complement: string
  }
  bankAccount: {
    bank: string
    agency: string
    account: string
    accountType: string
  }
  isActive: boolean
  blacklisted?: boolean
}

export async function register(params: RegisterParams) {
  const { data } = await httpClient
    .post<RegisterResponse>('/user', params)
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
